import { GuideOrderThemeModeConfig } from './types';

const dark: GuideOrderThemeModeConfig = {
  guideOrder: {},
};

export default dark;
